/* eslint no-use-before-define: 0 */ // --> OFF
<template>
  <div class="calendar-container">
    <vue-scheduler-v
      @event-clicked="eventClicked"
      @event-canceled="eventCanceled"
      @event-created="eventCreated"
      @setScrollLoading="loadingData"
      @save-call="saveCall"
      :event-dialog-config="dialogConfig"
      event-display="name"
      initial-view="day"
      :initial-date="initialDate"
      :events="events"
      :available-views="['month', 'day']"
      :estTime="estTime"
      :mode="mode"
      :shift="shift"
    ></vue-scheduler-v>
  </div>
</template>

<script>
// import apiClientCreator from "../../../../helpers/api/request";
import VueSchedulerV from "./v-calendar-scheduler/components/VueScheduler";
import "./v-calendar-scheduler/scss/_variables.scss";
import "./v-calendar-scheduler/scss/main.scss";
import { EventBus } from "./v-calendar-scheduler/components/EventBus";
// import { setTasks } from "../../../../store/tasks.store/mutations";
export default {
  components: {
    VueSchedulerV
  },
  props: {
    sheduleCallReasons: {
      type: Array
    },
    initialDate: {
      type: Object
    },
    events: {
      type: Object
    },
    mode: {
      type: String
    },
    shift: {
      type: Array
    },
    activeDate: {
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tasksFromDb: null,
      choosedDate: null,
      // startDisplayDate: new Date(),
      startDisplayDate: this.initialDate,
      dialogConfig: {
        title: "Choose A Time",
        createButtonLabel: "Next",
        enableTimeInputs: true
        // fields: [
        //   {
        //     name: 'name',
        //     label: 'Event name'
        //   },
        //   {
        //     name: 'email',
        //     type: 'email',
        //     required: true,
        //     label: 'E-mail',
        //     value: 'email@example.com'
        //   },
        //
        //
        // ]
      }
    };
  },

  methods: {
    loadingData(element){
      this.$emit("setScrollLoading", element);
    },
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },
    showTaskOnCalendar(tasks) {
      let eventsList = [];
      tasks.data.forEach(task => {
        let details = {
          date: task.start_time,
          startTime: this.formatStartDateForCalendar(task.start_time),
          endTime: this.formatEndDateForCalendar(task.end_time),
          name: this.setTaskInfoOnCalendar(task),
          eventClass: this.setEventClass(task.type_id),
          task_id: task.id,
          task_status: this.setEventClassByStatus(task.status_id)
          // user: this.getUsersAssignment(task.task_assignment)
        };

        eventsList.push(details);
      });
      // this.events = eventsList;
    },

    setTaskInfoOnCalendar(task) {
      if (task.content !== undefined && task.content !== null) {
        return `${this.removeHtml(task.content)}`;
      }
    },

    formatStartDateForCalendar(time) {
      if (time != null || time != undefined) {
        let startTime = time.slice(11, 16);
        return startTime;
      } else {
        return time;
      }
    },

    formatEndDateForCalendar(time) {
      if (time != null || time != undefined) {
        let endTime = time.slice(11, 16);
        return endTime;
      } else {
        return time;
      }
    },

    setEventClass(type_id) {
      if (type_id !== undefined) {
        let eventClass;
        switch (type_id) {
          case 1:
            eventClass = "event-task";
            break;
          case 2:
            eventClass = "event-meeting";
            break;
          case 3:
            eventClass = "event-announcement";
            break;
          case 4:
            eventClass = "event-comp-meeting";
            break;
          case 5:
            eventClass = "event-repeated-task";
            break;
          case 6:
            eventClass = "event-opening-shift";
            break;

          default:
            eventClass = "event-task";
        }
        return eventClass;
      }
    },
    setEventClassByStatus(task_status) {
      if (task_status !== undefined) {
        let eventClassByStatus;
        switch (task_status) {
          case 1:
            eventClassByStatus = "event-completed";
            break;

          default:
            eventClassByStatus = "event-task";
        }
        return eventClassByStatus;
      }
    },
    eventClicked(event) {
      this.$emit("clickedCall", event);
    },
    eventCanceled(event) {
      this.$emit("eventCanceled", event);
    },
    saveCall(event) {
      this.$emit("saveCall", event);
    },

    eventCreated(event, reason, comment,replaceClients) {
      this.choosedDate = event;
      this.$emit("createCall", event, reason, comment,replaceClients);
    },
    dayClicked(date) {},
    timeClicked(dateWithTime) {},
    getUsersAssignment(task_assignment) {
      let usersAssignment = [];
      task_assignment.forEach(item => {
        usersAssignment.push(item.assigned_to);
      });
      return usersAssignment;
    }
  },
  mounted() {}
};
</script>

<style scoped lang="sass">
@import "./v-calendar-scheduler/lib/main.css"
</style>
